<script>
import CourseActivitiesComponent from '../features/boxes/CourseActivitiesComponent';
import ModalCoursePublicActivityView from '../modals/ModalCoursePublicActivityView';

export default {
  components: {
    'modal-course-public-activity-view': ModalCoursePublicActivityView,
  },
  extends: CourseActivitiesComponent,
};
</script>

<template>
  <div>
    <div
      v-for="(activity, activityIndex) in orderActivities(
        courseSubject.courseSubjectActivities
      )"
      :key="activityIndex"
      class="lecture-container"
    >
      <el-col :span="20">
        <el-row>
          <el-col>
            {{ activity.title }}
          </el-col>
          <el-col>
            <el-tag effect="plain">
              <i class="el-icon-time" /> {{ activity.getDuration() }}
            </el-tag>
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :span="2"
        align="center"
      >
        <el-button
          v-if="activity.isPublic"
          link
          class="preview-text"
          @click="onShowPublicActivity(activity)"
        >
          Ver
        </el-button>
      </el-col>
      <el-col
        :span="2"
        align="center"
      />
    </div>
    <modal-course-public-activity-view
      v-if="modalItemCoursePublicActivity.isVisible"
      :conf="modalItemCoursePublicActivity"
      :form-data="activityPreview"
    />
  </div>
</template>
